import './frontend.scss';
import React from 'react';
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import CatalogSingle from './frontend/CatalogSingle';
import CatalogShopGrid from './frontend/CatalogShopGrid';
import CatalogShopList from './frontend/CatalogShopList';


// Initialize the React app
domReady(() => {
  const gmpwcp_catelog_single = document.getElementById('gmpwcp_catelog_single');
  
  if (gmpwcp_catelog_single) {
    const root = createRoot(gmpwcp_catelog_single);
    root.render(<CatalogSingle />);
  }
  const gmpwcp_catelog_shop_grid = document.getElementById('gmpwcp_catelog_shop_grid');
  
  if (gmpwcp_catelog_shop_grid) {
    const root = createRoot(gmpwcp_catelog_shop_grid);
    root.render(<CatalogShopGrid />);
  }

  const gmpwcp_catelog_shop_list = document.getElementById('gmpwcp_catelog_shop_list');
  
  if (gmpwcp_catelog_shop_list) {
    const root = createRoot(gmpwcp_catelog_shop_list);
    root.render(<CatalogShopList />);
  }
});
